export enum AIAssistantAnswerReliabilityEnum {
  ACCEPTED = 'accepted',
  EDITED = 'edited',
  REJECTED = 'rejected',
}
